import { getClinicianCredentialsAsync } from "api/clinician";
import { useQuery } from "react-query";

export const useGetClinicianCredentials = (clinicianId) => {
  return useQuery(["clinicianCredentials"], () => getClinicianCredentialsAsync(clinicianId), {
    enabled: !!clinicianId,
  });
};
